import {makeAutoObservable} from "mobx";
import TaskService from "../service/TaskService";
import {fetchOneTask, updateTask} from "../http/TaskAPI";

export default class TaskStore {
    task = []
    taskId = {}
    isLoadingPr = false
    constructor() {
        makeAutoObservable(this)
    }

    setTask(task) {
        this.task = task
    }

    setTaskId(taskId) {
        this.taskId = taskId
    }

    setIsLoadingPr(bool) {
        this.isLoadingPr = bool
    }

    async addTask(task) {
        try {
            const {data} = await TaskService.createTask(task)
            this.setTaskId(data.id)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async addTaskFile(task) {
        try {
            const {data} = await TaskService.createTaskFile(task)
            this.setTaskId(data.id)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async addTaskToMsg(task) {
        try {
            const {data} = await TaskService.createTask(task)
            this.setTaskId(data.id)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async addTaskFileToMsg(task) {
        try {
            const {data} = await TaskService.createTaskFile(task)
            this.setTaskId(data.id)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async updTask(task) {
        this.setIsLoadingPr(true)
        try {
            const {data} = await updateTask(task)
        } catch (e) {
            console.log(e.response?.data?.message)
        } finally {
            this.setIsLoadingPr(false)
        }
    }


}